import React from "react";
import {
  FaUsers,
  FaUserTie,
  FaBriefcase,
  FaClipboardList,
  FaCreditCard,
  FaRupeeSign,
} from "react-icons/fa";

const iconMap = {
  Candidates: <FaUsers size={26} />,
  Recruiters: <FaUserTie size={26} />,
  Jobs: <FaBriefcase size={26} />,
  Applications: <FaClipboardList size={26} />,
  Payments: <FaCreditCard size={26} />,
  Revenue: <FaRupeeSign size={26} />,
};

const colorMap = {
  primary: "bg-blue-100 text-blue-700",
  success: "bg-emerald-100 text-emerald-700",
  warning: "bg-yellow-100 text-yellow-700",
  info: "bg-cyan-100 text-cyan-700",
  secondary: "bg-purple-100 text-purple-700",
  danger: "bg-red-100 text-red-700",
};

function StatCard({
  title,
  value,
  color = "primary",
  change,
  changeType,
}) {
  return (
    <div className="bg-white rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 p-6">

      <div className="flex justify-between items-center">

        <div>

          <p className="text-gray-500 text-sm font-medium">
            {title}
          </p>

          <h2 className="text-4xl font-bold text-gray-800 mt-3">
            {value}
          </h2>

          {change && (
            <p
              className={`mt-3 text-sm font-semibold ${
                changeType === "increase"
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              {change} This Month
            </p>
          )}

        </div>

        <div
          className={`w-16 h-16 rounded-2xl flex items-center justify-center ${colorMap[color]}`}
        >
          {iconMap[title]}
        </div>

      </div>

    </div>
  );
}

export default StatCard;